export default "__VITE_ASSET__B18Mx3cj__"